exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-menu--horizontal .el-menu--popup{\n  min-width: 96px !important;\n  text-align: center;\n}\n", ""]);

// exports
